const domain = "/dev-api/system/vip/";
let url = {
    'userLogin': domain + 'login/user',
    'userRegister': domain + 'login/register',
    'reset': domain + 'reset/password',
    'sms': domain + 'send/sms',
    'bindCard': domain + 'bind/card',
    'cardInfo': domain + 'card/info',
    'carduseInfo': domain + 'card/use/info/list',
    'rechargeInfo': domain + 'card/recharge/info/list',
    'info': domain + 'info',
    'infoList': domain + 'card/data/info/list',
}
export default url;


// WEBPACK FOOTER //
// ./src/utils/api.js